import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

const container = document.getElementById("root")!;

// Check if pre-rendered content exists
const isPrerendered = document.querySelector('meta[name="prerendered"]');

// Always use createRoot to avoid hydration mismatch errors (#418, #423)
// The pre-rendered HTML still benefits SEO (crawlers see content before JS loads)
// React will rebuild the UI from scratch on the client
createRoot(container).render(<App />);

// Signal to pre-renderer that the app is ready for capture
// This fires after React has finished rendering and useEffect hooks have run
// The pre-renderer waits for this event before capturing HTML
if (typeof window !== 'undefined') {
  // Use MutationObserver for more reliable detection of render completion
  const signalReady = () => {
    // Mark for pre-renderer injection detection
    (window as any).__PRERENDER_INJECTED = true;
    document.dispatchEvent(new Event('prerender-ready'));
  };

  // Wait for React Query data to load and SEO components to render
  // Check for key SEO elements before signaling ready
  const checkReadiness = () => {
    const hasTitle = document.title && document.title !== 'شركة خبراء مكة | خدمات التنظيف ومكافحة الحشرات ونقل العفش والصيانة';
    const hasSchema = document.querySelector('script[type="application/ld+json"]');
    const hasContent = document.querySelector('main') || document.querySelector('[role="main"]');
    
    return hasTitle || hasSchema || hasContent;
  };

  // For pre-rendering: wait for content, then signal
  if (!isPrerendered) {
    let attempts = 0;
    const maxAttempts = 40; // 40 * 100ms = 4 seconds max
    
    const waitForContent = setInterval(() => {
      attempts++;
      if (checkReadiness() || attempts >= maxAttempts) {
        clearInterval(waitForContent);
        // Additional delay for any async meta updates
        setTimeout(signalReady, 500);
      }
    }, 100);
  }
}
